import React from 'react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { Waves } from './Waves';
import { Seed } from './Seed';
export function Close() {
  return <section className="w-full bg-white" data-id="element-47" data-mp="1uy2w0t2pqz0m">
      <Waves to="#1A0B22" data-id="element-48" data-mp="1ux1imhy860fq" />
      <div className="stage-smoke relative overflow-hidden text-white" data-id="element-49" data-mp="1v0fo3z26qpre">
        <p aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-6 select-none text-center font-poster text-[26vw] uppercase leading-none text-white/[0.06] lg:text-[270px]" data-id="element-50" data-mp="1pygj6kqsrksc">
          Bollywood
        </p>
        <div className="relative mx-auto max-w-3xl px-5 pb-16 pt-10 text-center sm:pb-20" data-id="element-51" data-mp="1c7lhptimo5ys">
          <Seed className="mx-auto h-16 w-16" data-id="element-52" data-mp="178qri6ibzf4n" />
          <h2 className="mt-5 font-display text-4xl leading-tight sm:text-6xl" data-id="element-53" data-mp="17a1rdv8no2qh">
            Stop winging it. <span className="text-peach" data-id="element-54" data-mp="128cgqgpchr2x">Teach Bollywood with a plan.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base text-white/80" data-id="element-55" data-mp="xbm27xt6v3jm">
            Your teaching engine, a beginner term, kids classes, adult and
            drop-in classes, build-your-own routines and the show. Six
            volumes: counted, levelled and ready.
          </p>

          <div className="mt-7" data-id="element-56" data-mp="3lhr0m7whdqg2">
            <Countdown size="sm" data-id="element-57" data-mp="3lisf6mcpgv2j" />
          </div>

          <div className="mx-auto mt-6 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-3xl bg-white px-5 py-4 text-left shadow-card" data-id="element-58" data-mp="3qg2ceo6c6b0x">
            <div data-id="element-59" data-mp="i1a8ii8o5u3p">
              <span className="block text-xs font-bold text-teal-deep" data-id="element-60" data-mp="hyo1qktlrimj">Complete package</span>
              <span className="text-[15px] font-semibold text-navy" data-id="element-61" data-mp="mxisqa1q4dhq">Bollywood Class Ready, 6 volumes + 5 bonuses</span>
            </div>
            <div className="flex items-baseline gap-2.5" data-id="element-62" data-mp="d0wa7rwvdyiv">
              <span className="text-[15px] text-navy-muted line-through" data-id="element-63" data-mp="d3iijtrl4i25">$90</span>
              <span className="font-display text-4xl leading-none text-navy" data-id="element-64" data-mp="2sr0f6zgv7rk2">$27</span>
            </div>
          </div>

          <div className="mx-auto mt-5 max-w-lg" data-id="element-65" data-mp="2xpk0qyrjr1bw">
            <CtaButton data-id="element-66" data-mp="1497dghr0u2ip">Yes, I want Bollywood Class Ready for $27</CtaButton>
          </div>

          <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-67" data-mp="z9kvxw45u043">
            {['Secure checkout', 'Instant access', '7-day guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-68" data-mp="pkjhiad9jqs8">
                <span className="h-1.5 w-1.5 rounded-full bg-peach" data-id="element-69" data-mp="pi73276pryjx" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}